import { useNavigate } from 'react-router-dom';
import { articleCards } from '@/mocks/articles';

export default function ArticleCards() {
  const navigate = useNavigate();

  return (
    <section className="bg-background-100 py-20 md:py-28 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 font-semibold mb-4">
            Полезные статьи
          </h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto font-sans">
            Узнайте больше о том, как эффективно использовать YOYBUY Spreadsheet для заказа товаров из Китая
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articleCards.map((card) => (
            <article
              key={card.slug}
              className="relative rounded-3xl overflow-hidden min-h-[280px] group cursor-pointer"
              onClick={() => navigate(card.path)}
            >
              <img
                src={card.imageUrl}
                alt={card.title}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/15 to-transparent"></div>
              <div className="absolute top-5 left-5">
                <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-foreground-950/60 text-background-50 text-xs font-medium font-sans whitespace-nowrap">
                  {card.category}
                </span>
              </div>
              <div className="absolute bottom-5 left-5 right-5">
                <h3 className="font-sans text-background-50 text-lg font-semibold leading-snug mb-1">
                  {card.title}
                </h3>
                <p className="text-background-50/70 text-sm font-sans">
                  {card.subtitle}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}